import { render, staticRenderFns } from "./attachmentsViewer.vue?vue&type=template&id=778b7db6"
import script from "./attachmentsViewer.vue?vue&type=script&lang=ts"
export * from "./attachmentsViewer.vue?vue&type=script&lang=ts"
import style0 from "./attachmentsViewer.vue?vue&type=style&index=0&id=778b7db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports